import { FormControl, FormControlProps } from '@chakra-ui/react'

export type { FormControlProps }

export default FormControl
